import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/Users/brandonwu/Documents/PTS/Gatsby/Instana-1-Day-Partner-Workshop/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const Title = () => <span>
    Lab 6 - Application Perspectives <br />
  </span>;
;
export const _frontmatter = {};
const layoutProps = {
  Title,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2>{`Lab Overview`}</h2>
    <p>{`In this lab you will learn how to utilize Instana’s Application Perspective using your custom tags and zones. The Application Perspective (AP) auto-generates a feature rich monitoring dashboard where users can stay focused on the services they are interested in and not be distracted. AP’s can be customizable by technology, zone/cluster, version/release, and more. Alerts, errors, and logs are scoped to an AP to focus the troubleshooting.`}</p>
    <h2>{`Step 1:`}</h2>
    <p>{`Click on the STAN icon`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "64px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "112.5%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAXCAYAAAALHW+jAAAACXBIWXMAABYlAAAWJQFJUiTwAAADy0lEQVQ4y6WU209cVRTGNzMww3XuM2fmzJkrDDeBIlKwxYKChba0KQVLS61CSQukCtoGGopVAyRiCmjbZASKhth6S6yJiW20TfAS0xjji4lPPhj/Am3VB/v2M2cfaAExaH34cpKZld/+1t5rfeLPO3f45dYtfr19+39JZ/z2+x+I5MIlrJECApuq8ZVW3pf8ZZuxJUqobWlHnE3OITKcmIO5CCWKUCL/WSmBGMLup7h2O2J6dh5hU0iPFpIWStyXrOF8hCfEpoadiKmZi4gcr2w7VcuTTvVvqpYgNbSOVtUYsoQSCLdGWf2O1cCVhSYlTIpHxeTVFSRF//q0pZrEqtp1gD6skXyjMBDDpITILK/D3dyDcnAYpWMET0s/OVv2LB0Wkm51qK71HUYLMfkjWHLLUA69QPDYJN69x7HXtmGr2Yt7xxECnaMEj54lq6JBul2G/h1o82HRcrHmP4jW9zqe3b3GRWc7ETkuhMOHyLRj9oexb91D6NmkdLsMXQOcly1bQnmo3RO4GjsRDo/8raiuibnLH/Dx9UWaDnUhXEGE3U1maQ3hgVnSi6qMrvTD7wJn30RYs3E9dgC1axzhCZCTKKX/zBjXFr9k4sIMIxOTfHTtOsmFy0Sq6yTU1dSF/8kXMfmCWMIFa4DpNrQj49gfaUFkOXlp6jw//vQzhdseR2S65Jya1DhXrn7KJzc+xxpOkBopItgzhTW/grRgHOFZBr4xh3AGCfe9RkZhJcLhZ+bSeyQX3jFaUSJkRAsRdoWjg8Pc+OomSlkVwq0SeOplsqt3keoPy8GWwMnkLMITJXL8HNZ4CcKlcn5+gdHpC2xpbkUtr5Yz+nBzK4f7T3Dl6mcG0OlD6TiNbVsrZkW7BzQcqobDos0Iu4+33v+QcxcX2H/sGer2HaSgpoHuE6cYGpvgi5vfGkDPksOqnasdGo9iQ+scw1HbJkel++Qw333/g3yMgTOjnBp/lZ6hERa//oaZt9/FrMZIi5eg9U5jTZSvuUMJzMFZ24ba/QpmJYTwhjjQNyBhejR5iivYdbibwbEJ0mPFcqyMLTot13L1Ky/PYTBO4Okx3M29pLh8CGcAEYgj/DH5MGYtIV3osOyKejmH1kQF5kB0zRwub0ooD8tSG97W541V9AUxS2kyHNLUGI66JyQs66Ht/7Qp93ZZPy0tUoSvfcgA73sOR30H9kfbZYv6lejKKK3ZYJdXpo0ak84yHtiKs7ETb9tJfPsHce/uJbuyUR5q8ofvwv5lHibkjuptrpQeW+al/zfIw/USO2+dtN44sf8CytYBALJu1+oAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Lab 6",
        "title": "Lab 6",
        "src": "/Instana-1-Day-Partner-Workshop/static/f0429fc7954953eae23d5c642cda514f/512a8/6.1.png",
        "srcSet": ["/Instana-1-Day-Partner-Workshop/static/f0429fc7954953eae23d5c642cda514f/512a8/6.1.png 64w"],
        "sizes": "(max-width: 64px) 100vw, 64px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`For the purposes of this lab, we will be utilizing the tags that we created in the previous labs. You will
remember creating a tag called <Student=LAST NAME>. We will be utilizing this tag to create an Application Perspective.`}</p>
    <h2>{`Step 2:`}</h2>
    <p>{`Click the New Application Perspective to create a new AP`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "19.444444444444443%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAECAYAAACOXx+WAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAqklEQVQY03WOS07EMBAFc//zsRohEKyw4yQex9+224WSLcyTavlKtRhjcM4RU+Kazsn8B1VlAvL1zvn5IHx/kB5vDGcRndTWEOksu/f8mJVcKqqTMZShf6kyyDKIm6P4g8Na0mrpteLDScqFJnIJn9h1u8v6GC9JrXNWuc9VYT8zubS7zqwbISZqExYfAtbtSO9IHy/JTYiX8BkoMjhCIuV8l7vdE1Om1MYvlqc25onJP8QAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Lab 6",
        "title": "Lab 6",
        "src": "/Instana-1-Day-Partner-Workshop/static/33e2fc82605807d4c28a3ef3f8895b73/3cbba/lab6.2.png",
        "srcSet": ["/Instana-1-Day-Partner-Workshop/static/33e2fc82605807d4c28a3ef3f8895b73/7fc1e/lab6.2.png 288w", "/Instana-1-Day-Partner-Workshop/static/33e2fc82605807d4c28a3ef3f8895b73/a5df1/lab6.2.png 576w", "/Instana-1-Day-Partner-Workshop/static/33e2fc82605807d4c28a3ef3f8895b73/3cbba/lab6.2.png 1152w", "/Instana-1-Day-Partner-Workshop/static/33e2fc82605807d4c28a3ef3f8895b73/0b124/lab6.2.png 1728w", "/Instana-1-Day-Partner-Workshop/static/33e2fc82605807d4c28a3ef3f8895b73/4ea69/lab6.2.png 2304w", "/Instana-1-Day-Partner-Workshop/static/33e2fc82605807d4c28a3ef3f8895b73/14e11/lab6.2.png 2444w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <h2>{`Step 3:`}</h2>
    <p>{`Select Custom Tags.`}</p>
    <p>{`Then click Next.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "61.11111111111111%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAABYlAAAWJQFJUiTwAAACC0lEQVQoz41SXYvUQBDM3/bR3+KLKByCCgvH6eOBnA8q3q73ld1kk03SSWaSzGeymZIZd4P6dA1FNwWpVFdPxHmHLDsgSfdI0wxZfsB2l6Dve8zzjOPxGHCepxP8zK1FbQzIGAzWwhiLaJiA1jrkncaeKxSDBRsBNSOU/3icjtDGwuHfMnaEUBpSG8zOwTmHiHc9iopQ1Q1K8qjDTHWDljHUTYuyIrSMoygJfiPGeOCElItzdxYsygoPTzF2SYpDUSLepVjfPeD+McY22WOXZrh7eEKyz0NP93ngf90/QSm9uPVivqJpmiCVhhAyEIz/+Xs/CAipMAgR0PUDBiGDyDAISKVgrYXSOrg8i0aeaFq/GsM4TWCM4Xa9RpbnMMZAKQWtNYzRp25C97yHPK29CEqpQk7egRf0jtebTUDTNDDW4jm1rOyPkhdluKYvzjmSNMU+y9C2DF3XhSfku4/lHP7/WBz6HETfw01jIA9liTiO0bYtnlt/C0e7z5fu62rlvl1eusOXaycPmbuPY7fdbl2WZQFFRa6qyBHVLi9LVxSF45y7cRydc7O3tyD6+fE9rt59wOrtBTafroC2AhMSVUWgug75UrLD5vZHAG1jsCWGHnYcw6P2h5lnv3LH6MgbmruWLG+pV5qkNqSMDeiEovTmml68eUUvL15T9/2G1HikQSoSStMgdZjP+A2jA5LwIUhWhwAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Lab 6",
        "title": "Lab 6",
        "src": "/Instana-1-Day-Partner-Workshop/static/246aa90eb6f7236f6ae49f356d529ce7/3cbba/lab6.3.png",
        "srcSet": ["/Instana-1-Day-Partner-Workshop/static/246aa90eb6f7236f6ae49f356d529ce7/7fc1e/lab6.3.png 288w", "/Instana-1-Day-Partner-Workshop/static/246aa90eb6f7236f6ae49f356d529ce7/a5df1/lab6.3.png 576w", "/Instana-1-Day-Partner-Workshop/static/246aa90eb6f7236f6ae49f356d529ce7/3cbba/lab6.3.png 1152w", "/Instana-1-Day-Partner-Workshop/static/246aa90eb6f7236f6ae49f356d529ce7/152d6/lab6.3.png 1422w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <h2>{`Step 4:`}</h2>
    <p>{`Select Miscellaneous from the drop down.`}</p>
    <p>{`Select Agent Tag. Select Student from the list of Tags. Select “your last name” from the list of values.`}</p>
    <p>{`Please notice the preview that is displayed. This will give us validation that our filter is properly formatted.`}</p>
    <p>{`Click Next.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.72222222222222%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAABYlAAAWJQFJUiTwAAACKklEQVQoz21SWY4TMRDtO3MRTsEHEh9cAoSYkVCkQSSZZMIsWTpLe3fZLtdD7s7AfFDS07O7Xdur6rQ23B+O2G33stvu0R96PD+9QCsN1AphHvn1XAujlAIuDJ8zFBEGIhgixEjoFBEfYsTjoOThdMaT1tj7gFPO0CJo/3Y+YOs8+ubMjCICEYEngg4BJkaUWlFrRWe8Z+U8VCTRRFAxQnsPdUWvNE7aoB8UdIjIAASTtQC1Vc11vLck3eF44rv5Eo/zuTzMZtjMF7hbrLBcb/Dw+wmr9QaL5QrL+zWOp/PolEtBLjxyYQbXOmKsMDjL5uUZ+varXL5/gZ3dYNhtQZczYsqgwkjMoFKQCmMwDv1lwEUbDMZCOw9HCSYklMLo0nHPdvETdrUQ1/h+DrtegtZzBOtQeMqccgYzI+WCQWkY68A8VZZzggs0nrsQAgdrEZyT4HxjROfAOeHV5DqEBqKEw/E0th9iBFdBiQHB2CkgpcRNC22cKG2hjYWPNGpTXleE+V/AXHBRGpQyqgClVJikMEQ1aeiI2OSMvbHyrDS22qBN3YcIFwKs84iUxmDNgbzHcD4jteqIxgopKJA9olZBl3JmFgGLyMh/l+I/1gYzu8Hx9hv83Q/UXzPklEZdtUtTyyllvmaXeh09v8HUeoEKHmfvEb2H0QbUljnnUZa2QpYmiTrrA7f1CJQkUMJbtO/GR+jLBe8/f8S7Tx+w36xRgOnN5Hd9O/EfvQqdJjtLiqQAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Lab 6",
        "title": "Lab 6",
        "src": "/Instana-1-Day-Partner-Workshop/static/a11afcafc053e9b6601c8e5da08532e5/3cbba/lab6.4.png",
        "srcSet": ["/Instana-1-Day-Partner-Workshop/static/a11afcafc053e9b6601c8e5da08532e5/7fc1e/lab6.4.png 288w", "/Instana-1-Day-Partner-Workshop/static/a11afcafc053e9b6601c8e5da08532e5/a5df1/lab6.4.png 576w", "/Instana-1-Day-Partner-Workshop/static/a11afcafc053e9b6601c8e5da08532e5/3cbba/lab6.4.png 1152w", "/Instana-1-Day-Partner-Workshop/static/a11afcafc053e9b6601c8e5da08532e5/0b124/lab6.4.png 1728w", "/Instana-1-Day-Partner-Workshop/static/a11afcafc053e9b6601c8e5da08532e5/4ea69/lab6.4.png 2304w", "/Instana-1-Day-Partner-Workshop/static/a11afcafc053e9b6601c8e5da08532e5/0d5e3/lab6.4.png 2386w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <h2>{`Step 5:`}</h2>
    <p>{`Name your AP Student “your last name”`}</p>
    <p>{`Select All Calls.`}</p>
    <p>{`Click Create.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "59.72222222222222%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAABYlAAAWJQFJUiTwAAACDUlEQVQoz32SXW7bMBCEdelepJfoU/vUY/SlaJA0TuzEiRPHliyR4v+fvoK0U6BoUQIDrpbk7M6sOilnjoee/f7QcDj07HavSDGzlIWSC0tFKS3OKTfUnEuJOURkCOgQ8T7Qzc5wspKXsed5OLAXA70WiKAxJTB5zckqBjMjo8UsoeV19rypiWdx4mUeGaPBpkCnrEUajXIWoXWLtTvnKgYhGMTEIAXjLJFaMVvNpGaUNfgU8TGQlkwqme74duD66obt45b7uzXb7TMPj09sn3bsXvbcrtasN49sHrY87165/nnH6n7D7d0aKRV1lWpNKc2iznz/hrj+gV5dU1ZXEAP/W9p5plmhrEMo3VRpH5htIKVMZ8cTc98jj0fMacAai7EW6xzGnPda/R0+RMZJIJUm5UwuCzEGtPXkUuhCTIRU6KVmkAqlDboR+QbnfCNJKbEsS5vksT/RD2M7r4TJWeysLoQpE5RkWt/ipxEXIiHE9vgdORfKJa7kp0ngfGjepVSYg2B0oinoTEyMcuK4ummytXWty3cY6wjxXKBcCCchiTG1QrXDYAVeDa1AF2NsZi9Abt3k88UL2vSW5fdQqoIqudqSciFWhfXn1vEsuVasjyrR2fjlD+TLmTCGkzE459pAfAhtKHWylVT53L672dhW1frwF2peGYcYJz5+/cyHL5/YbzekhX/cPe+/ADsSnja/8NSeAAAAAElFTkSuQmCC')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "Lab 6",
          "title": "Lab 6",
          "src": "/Instana-1-Day-Partner-Workshop/static/dd0af381a48d60dbb595986ee2c62e9f/3cbba/lab6.5.png",
          "srcSet": ["/Instana-1-Day-Partner-Workshop/static/dd0af381a48d60dbb595986ee2c62e9f/7fc1e/lab6.5.png 288w", "/Instana-1-Day-Partner-Workshop/static/dd0af381a48d60dbb595986ee2c62e9f/a5df1/lab6.5.png 576w", "/Instana-1-Day-Partner-Workshop/static/dd0af381a48d60dbb595986ee2c62e9f/3cbba/lab6.5.png 1152w", "/Instana-1-Day-Partner-Workshop/static/dd0af381a48d60dbb595986ee2c62e9f/0b124/lab6.5.png 1728w", "/Instana-1-Day-Partner-Workshop/static/dd0af381a48d60dbb595986ee2c62e9f/4ea69/lab6.5.png 2304w", "/Instana-1-Day-Partner-Workshop/static/dd0af381a48d60dbb595986ee2c62e9f/07ea3/lab6.5.png 2428w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy",
          "decoding": "async"
        }}></img>{`
    `}</span>{` `}</p>
    <h2>{`Step 6:`}</h2>
    <p>{`Validate the new Application Perspective. It will take a minute or so before you see data populate the AP Dashboard.`}</p>
    <p>{`To do this, start by clicking Application.`}</p>
    <p>{`Make sure to turn on Live mode.`}</p>
    <p>{`Verify that the new Application Perspective is listed.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "65.97222222222221%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAABYlAAAWJQFJUiTwAAACJ0lEQVQ4y32SvW4TQRDH77lIQSoqGgMiiQgVvAOi4XkoeQMKGhoiIRR8SbDPZzuciEjs2He7O1/7R7tnbIIQJ43mf7Oj33xoiqvrG1ut17Zc3tqkntu38dSqem7jySzbVtdzq6aXNprMbFTNrJ43Vtczm48rq84rK4czOzn5bMXLV2+wWNzix9VPtJ2DDwQfwsbvLNCfmhFY4OsRVmenWJ6XaKsKZx/eo3j45Ch2gaILIQbi6HyIxBJFLYrq/229iry4ibS4iSAXy5NPsXh9/AzLtsOqbSEiYJHsRXRnqruY/o4LxCIkAkEUBuC0PEPx4PgFWufQOY8IIMYIVctgU82eWNILeFMAMWbvfUA0AxEhfcPhEMX+4ADu+xQyr6GLayiQAclUFUEMXeCsPStcoKxFLe8zgfuCwLAsUew/PsL6coowraC3C2jsgeFvoPTAzt8FcgZyBn75OkRx/+lzeNU8ppjlHeUk0Q1Q4Ui22hP3e7wD7Ds8v7hAsffoEC0zAklO7Pe3A9IGkuIhjexDjqecpPPI0gOryQTFvcFBBnaet0DaVM3AND4RLC2fuQdmLXDO/wt4aC2RdZ5NVE1VLXAyyf/EYj6QqZkFYnMubHXnvLH0OQDsYjyx3GHHDOK+u1x9O3J/PkQMs5i7SntLmpNOI29OK53cqJqg2BscNisfmnUXGmLO5okbH6jXgZrO+YZFGpfy2m6rV+s2v5tQ865yzduPZfML+PLWMbT07SYAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Lab 6",
        "title": "Lab 6",
        "src": "/Instana-1-Day-Partner-Workshop/static/349c5abbfab0c21d8425d675e6571dad/3cbba/lab6.6.png",
        "srcSet": ["/Instana-1-Day-Partner-Workshop/static/349c5abbfab0c21d8425d675e6571dad/7fc1e/lab6.6.png 288w", "/Instana-1-Day-Partner-Workshop/static/349c5abbfab0c21d8425d675e6571dad/a5df1/lab6.6.png 576w", "/Instana-1-Day-Partner-Workshop/static/349c5abbfab0c21d8425d675e6571dad/3cbba/lab6.6.png 1152w", "/Instana-1-Day-Partner-Workshop/static/349c5abbfab0c21d8425d675e6571dad/0b124/lab6.6.png 1728w", "/Instana-1-Day-Partner-Workshop/static/349c5abbfab0c21d8425d675e6571dad/1a52e/lab6.6.png 2274w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      